import axios from "axios";

const AUTH_TOKEN_KEY = "shipmenttracker_auth_token";

export function getApiBaseUrl() {
  const explicitBaseUrl = process.env.REACT_APP_API_BASE_URL?.trim();
  if (explicitBaseUrl) {
    return explicitBaseUrl.replace(/\/+$/, "");
  }

  if (typeof window === "undefined") {
    return "http://127.0.0.1:8000";
  }

  const { origin, protocol, hostname, port } = window.location;
  // Keep both public frontend URLs pinned to the active backend service.
  if (
    hostname === "shipmenttracker-frontend-cs42.onrender.com" ||
    hostname === "shipmenttracker-frontend.onrender.com" ||
    hostname === "admin.easemyshipping.com"
  ) {
    return "https://shipmenttracker-backend-cs42.onrender.com";
  }

  if (hostname.endsWith(".onrender.com")) {
    return `${protocol}//${hostname.replace("-frontend.", "-backend.")}`;
  }

  if (port === "8000") {
    return origin;
  }

  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return `${protocol}//${hostname}:8000`;
  }

  return origin;
}

export function buildApiUrl(path) {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${getApiBaseUrl()}${normalizedPath}`;
}

export function getAuthToken() {
  if (typeof window === "undefined") {
    return "";
  }
  return window.localStorage.getItem(AUTH_TOKEN_KEY) || "";
}

export function setAuthToken(token) {
  if (typeof window !== "undefined") {
    if (token) {
      window.localStorage.setItem(AUTH_TOKEN_KEY, token);
    } else {
      window.localStorage.removeItem(AUTH_TOKEN_KEY);
    }
  }
}

// For pages served directly by the backend (not the React SPA) - a plain
// browser navigation can't carry the Authorization header axios attaches,
// so the current token is embedded as a query param instead. Read fresh at
// call time, so links built with this always carry a live token rather than
// one that goes stale sitting in a rendered href.
export function buildBackendPageUrl(path) {
  const token = getAuthToken();
  const baseUrl = buildApiUrl(path);
  if (!token) {
    return baseUrl;
  }
  return `${baseUrl}${baseUrl.includes("?") ? "&" : "?"}portal_token=${encodeURIComponent(token)}`;
}

const API = axios.create({
  baseURL: getApiBaseUrl(),
  withCredentials: true,
});

API.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default API;
